import { render, staticRenderFns } from "./VideoPanel.vue?vue&type=template&id=17de6991&scoped=true"
import script from "./VideoPanel.vue?vue&type=script&lang=js"
export * from "./VideoPanel.vue?vue&type=script&lang=js"
import style0 from "./VideoPanel.vue?vue&type=style&index=0&id=17de6991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17de6991",
  null
  
)

export default component.exports